import cn from 'comma-number'

export const yearsValue = [10, 15, 20, 25, 30]
export const downPayPercents = [5, 10, 15, 20, 25, 30, 35, 40]
export const rateData = [
  {
    label: '5 yr variable - 3.99%',
    value: 3.99,
  },
  {
    label: '5 yr fixed - 4.5%',
    value: 4.5,
  },
  {
    label: '3 yr fixed - 5%',
    value: 5,
  },
]

/* eslint-disable */
export const downPaymentTips = 'Insurance Premiums are added when a downpayment is less than 20%. Premiums are 4%, 3.1% or 2.8% depending on the size of the downpayment relative to the mortgage.'

export const interestRateTips = 'View today’s rate or enter your own mortgage rate'

/* eslint-enable */
export const onDownPaymentBlur = ({ downPayment, prevDownPayment, downPaymentPercent, unitPrice }) => {
  if(prevDownPayment === downPayment) return null
  // minimum down is always 5%
  // enforce minimum down between 5% and 7.5% for homes between 500K and 1M
  // enforce minimum down pay if its over 1M
  if(downPaymentPercent < 20 && unitPrice >= 1000000) {
    return {
      downPaymentPercent: 20,
      downPayment: cn((unitPrice * 0.2).toFixed(0)),
      errorMsg: 'Minimum 20% down payment for over 1M',
    }
  } if(downPaymentPercent < 5 && unitPrice >= 500000 && unitPrice < 1000000) {
    return {
      downPaymentPercent: 6.9,
      downPayment: cn((unitPrice * 0.069).toFixed(0)),
      errorMsg: 'Between 500k to 1M requires 5% to 7.5% down',
    }
  } if(downPaymentPercent < 5) {
    return {
      downPaymentPercent: 5,
      downPayment: cn((unitPrice * 0.05).toFixed(0)),
      errorMsg: 'Minimum 5% down',
    }
  }
}

// For mortgage calculator --------------

/* eslint-disable */
export const mortgagePaymentTips = 'Insurance Premiums are added when a downpayment is less than 20%. Premiums are 4%, 3.1% or 2.8% depending on the size of the downpayment relative to the mortgage.'
export const totalMortgageTips = 'Calculated as price minus down payment plus mortgage insurance premium (if applicable)'
export const priceTips = 'Purchases greater than $1 million have a minimum down payment of 20%'
export const frequencies = {
  'Monthly': {
    value: 12,
    short: 'Monthly',
  },
  'Semi-Monthly': {
    value: 24,
    short: 'Semi-Monthly'
  },
  'Bi-Weekly': {
    value: 26,
    short: 'Bi-Weekly'
  },
  'Weekly': {
    value: 52,
    short: 'Weekly',
  },
}

export const strToNum = (str) => {
  if(typeof str === 'string') return Number(str.replace(/\D+/g, ''));
  return str
}

// basically add mortgage insurance to mortgage
export const mortgagePaymentWithPremium = (originPayment, downPayPercent) => {
  if(downPayPercent > 19) return originPayment
  if(downPayPercent < 10) {
    return originPayment * 1.04
  } else if(downPayPercent < 15) {
    return originPayment * 1.031
  }
  return originPayment * 1.0028
}

export const getInitState = (props) => ({
  price: props.price ? cn(props.price) : 0,
  unitPrice: props.price ? props.price : 0, // unit price, $
  downPayment: props.price ? cn((props.price * 0.1).toFixed(0)) : 0, // %
  downPaymentPercent: 10, // %
  mortgageAmortization: 30, // mortgage length, years
  mortgageRate: props.rate ? props.rate : rateData[0].value, // rate %
  maintenance: (props.maintenance) ? Number(props.maintenance) : 0,
  taxes: props.tax ? props.tax : 0,
  isCalcUsed: false,
  frequency: frequencies.Monthly,
  focusedDropdown: '',
  errorMsg: '',
})

export const whatYouPayTodayTip =
  "We use your current rental payments and subtract the potential monthly fees you’ll pay as a property owner to determine your mortgage budget."

export const homeYouCanAffordTip =
"We use the interest rate, amortization period, and down payment amount to calculate what your equivalent purchase price would be."

export const affordableHomeValueTip =
"The total value of a home you can afford based on your current rental payments and your down payment amount"
